import {
  INC_LOADING,
  DEC_LOADING,
  SET_ERROR_MESSAGE,
  SET_SNACKBAR_MESSAGE,
} from '@/modules/common/store/mutation-types'
import {
  FETCH_ORGANIZATION_COLLECTION_PLANS,
  ADD_COLLECTION_PLAN,
  UPDATE_COLLECTION_PLAN,
  PATCH_COLLECTION_PLAN,
  DELETE_COLLECTION_PLAN,
  FETCH_FILLABLE_FIELDS_FOR_COLLECTION,
  PATCH_FILLABLE_FIELDS_FOR_COLLECTION,
  ADD_COLLECTION_PLAN_GROUP,
  DUPLICATE_COLLECTION_PLAN_GROUP,
  DELETE_COLLECTION_PLAN_GROUP, PRE_ANNOUNCE_COLLECTIONS,
  FETCH_STATSENDPOINTS_FOR_COLLECTION_PLAN, SAVE_DONATION_METER, DELETE_DONATION_METER
  // PRE_ANNOUNCE_COLLECTIONS
} from './action-types'
import i18n from '@/i18n'
import { groupCollectionPlansByParentUrl } from '@/lib/collection-plan-utils'
import {
  SET_COLLECTION_PLAN_STATSENDPOINTS,
  SET_ORGANIZATION_COLLECTION_PLANS,
  UPDATE_COLLECTION_PLANS
} from '@/store/mutation-types'
export default {
  namespaced: true,
  state: function () {
    return {
      allCollectionPlans: [],
      rawCollectionPlansByOrganization: {},
      rawStatsendpointsByCollectionPlan: {},
    }
  },
  getters: {
    collectionPlansByOrganization: (state) => {
      /* This is currently a no-op, but could be used to filter/modify CollectionPlan objects as they come from the API */
      return Object.fromEntries(Object.entries(state.rawCollectionPlansByOrganization).map(([orgUrl, plans]) => [
        orgUrl, plans.map(plan => {
          return { ...plan }
        })
      ]))
    },
    statsendpointBySecretToken: (state) => {
      return Object.fromEntries(
        Object.entries(state.rawStatsendpointsByCollectionPlan).map(
          ([_, statsendpoints]) => statsendpoints.map(endpoint => [endpoint.secret_token, endpoint]).flat()
        )
      )
    },
    currentCollectionPlans: (state, getters, rootState, rootGetters) => {
      const org = rootGetters['organization/currentOrganization']
      if (!org) {
        return null
      }
      const collectionPlans = getters.collectionPlansByOrganization[org.url]
      if (!collectionPlans) {
        return null
      }
      return collectionPlans
    },
    collectionPlansLookup: (state, getters, rootState, rootGetters) => {
      const org = rootGetters['organization/currentOrganization']
      if (!org || !getters.collectionPlansByOrganization[org.url]) {
        return null
      }
      const result = {}
      getters.collectionPlansByOrganization[org.url].forEach(plan => {
        result[plan.url] = plan
      })
      return result
    },
    collectionPlanById: (state, getters, rootState, rootGetters) => {
      const org = rootGetters['organization/currentOrganization']
      if (!org || !getters.collectionPlansByOrganization[org.url]) {
        return null
      }
      const result = {}
      getters.collectionPlansByOrganization[org.url].forEach(plan => {
        result[plan.id] = plan
      })
      return result
    },
    collectionPlanGroupsByUrl: (state, getters, rootState, rootGetters) => {
      const org = rootGetters['organization/currentOrganization']
      if (!org || !getters.collectionPlansByOrganization[org.url]) {
        return null
      }
      return groupCollectionPlansByParentUrl(getters.collectionPlansByOrganization[org.url])
    }
  },
  mutations: {
    [SET_ORGANIZATION_COLLECTION_PLANS]: (state, {
      organizationUrl,
      data
    }) => {
      state.rawCollectionPlansByOrganization = {
        ...state.rawCollectionPlansByOrganization,
        [organizationUrl]: data
      }
    },
    [UPDATE_COLLECTION_PLANS]: (state, {
      organizationUrl,
      data
    }) => {
      const collectionPlans = state.rawCollectionPlansByOrganization[organizationUrl]
      const index = collectionPlans.findIndex(collectionPlan => collectionPlan.id === data.id)
      if (index !== -1) {
        state.rawCollectionPlansByOrganization[organizationUrl] = [
          ...collectionPlans.slice(0, index),
          data,
          ...collectionPlans.slice(index + 1)
        ]
      }
    },
    [SET_COLLECTION_PLAN_STATSENDPOINTS]: (state, { collectionPlanUrl, statsendpoints }) => {
      state.rawStatsendpointsByCollectionPlan = {
        ...state.rawStatsendpointsByCollectionPlan,
        [collectionPlanUrl]: statsendpoints
      }
    }
  },
  actions: {
    [FETCH_FILLABLE_FIELDS_FOR_COLLECTION]: async ({
      commit,
      rootGetters
    }, { token }) => {
      await commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.get('/collection_plan/fill_accounting_fields/' + token)
        return response.data
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        return null
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [PATCH_FILLABLE_FIELDS_FOR_COLLECTION]: async ({
      commit,
      rootGetters
    }, {
      token,
      data
    }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.patch('/collection_plan/fill_accounting_fields/' + token + '/', data)
        if (response.status === 200) {
          return true
        }
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return false
    },
    [FETCH_ORGANIZATION_COLLECTION_PLANS]: async ({
      commit,
      rootGetters
    }, param) => {
      let organizationUrl = ''
      let recursive = false
      if (typeof param === 'string') {
        organizationUrl = param
      } else {
        organizationUrl = param.url
        recursive = param?.recursive || false
      }
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.get(organizationUrl + 'collection_plans/' + (recursive ? '?recursive=1' : ''))
        await commit(SET_ORGANIZATION_COLLECTION_PLANS, {
          organizationUrl,
          data: response.data,
          recursive,
        })
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
        await commit(SET_ORGANIZATION_COLLECTION_PLANS, {
          organizationUrl,
          data: null
        })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [ADD_COLLECTION_PLAN]: async ({
      commit,
      rootGetters
    }, collectionPlan) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.post('collection_plan/', collectionPlan)
        if (response.status === 201) {
          return response.data
        }
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return false
    },
    [UPDATE_COLLECTION_PLAN]: async ({
      commit,
      rootGetters
    }, collectionPlan) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.put(collectionPlan.url, collectionPlan)
        if (response.status === 200) {
          return true
        }
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return false
    },
    [PATCH_COLLECTION_PLAN]: async ({
      commit,
      rootGetters
    }, {
      url,
      data
    }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.patch(url, data)
        if (response.status === 200) {
          return response.data
        }
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return false
    },
    [DELETE_COLLECTION_PLAN]: async ({
      commit,
      rootGetters
    }, collectionPlan) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.delete(collectionPlan.url)
        if (response.status === 204) {
          return true
        }
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return false
    },
    [ADD_COLLECTION_PLAN_GROUP]: async ({
      commit,
      dispatch,
      rootGetters
    }, {
      collectionPlanGroup,
      collectionPlanMembers
    }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        collectionPlanGroup.parent = null
        const groupResponse = await rootGetters.restApi.post('collection_plan/', collectionPlanGroup)
        const groupUrl = groupResponse.data.url

        const memberUpdateCalls = collectionPlanMembers.map((collectionPlan) => {
          collectionPlan.parent = groupUrl
          // KODI-529 & KODI-550: When editing the collection plan and the tags is an empty array, it will cause
          // an error in the backend. So we need to remove the tags from the collection plan object
          // to not indicate an empty array on purpose. By having the tags removed, the backend will
          // not update the tags of the collection plan.
          delete collectionPlan.tags
          return rootGetters.restApi.put(collectionPlan.url, collectionPlan)
        })

        await Promise.allSettled(memberUpdateCalls)
        return groupResponse.data
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }

      return false
    },
    [DUPLICATE_COLLECTION_PLAN_GROUP]: async ({
      commit,
      dispatch,
      rootGetters
    }, {
      collectionPlanGroup,
      collectionPlanMembers
    }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const memberCreateCalls = collectionPlanMembers.map((collectionPlan) => {
          const duplicateCollectionPlan = {
            ...collectionPlan,
            parent: null,
            id: null,
            url: null
          }
          return rootGetters.restApi.post('collection_plan/', duplicateCollectionPlan)
        })

        const duplicatedCollectionPlansResponses = await Promise.allSettled(memberCreateCalls)
        const duplicatedCollectionPlans = duplicatedCollectionPlansResponses.map((response) => response.value.data)

        const duplicateCollectionPlanGroup = {
          ...collectionPlanGroup,
          id: null,
          url: null
        }

        const result = await dispatch(ADD_COLLECTION_PLAN_GROUP, {
          collectionPlanGroup: duplicateCollectionPlanGroup,
          collectionPlanMembers: duplicatedCollectionPlans
        })

        return result
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [DELETE_COLLECTION_PLAN_GROUP]: async ({
      commit,
      dispatch,
      rootGetters
    }, { collectionPlanGroup, organizationUrl }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        // Always fetch the authoritative, complete member list from the backend rather than
        // trusting a caller-supplied list: callers may only have a filtered/narrowed view of
        // the organization's collection plans (e.g. the Planung page's running/recently-ended
        // plus viewed-year window), which would otherwise silently leave orphaned members
        // undeleted. The organization URL comes from the caller because the group itself may
        // be location-scoped (organization === null); group members share their parent's
        // organization/location, so the caller's non-recursive list contains all of them.
        const listUrl = (organizationUrl ?? collectionPlanGroup.organization) + 'collection_plans/'
        const response = await rootGetters.restApi.get(listUrl)
        const members = response.data.filter((plan) => plan.parent === collectionPlanGroup.url)
        await Promise.allSettled(members.map((collectionPlan) => dispatch(DELETE_COLLECTION_PLAN, collectionPlan)))
        await dispatch(DELETE_COLLECTION_PLAN, collectionPlanGroup)
        return true
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [PRE_ANNOUNCE_COLLECTIONS]: async ({
      commit,
      rootGetters
    }, { collectionId, organizationUrl }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        await rootGetters.restApi.post(`collection_plan/${collectionId}/pre_announce_collections/`, {
          organization: organizationUrl
        })
        commit(SET_SNACKBAR_MESSAGE, { message: 'Vorankündigungen werden verschickt' }, { root: true })
        return true
      } catch (error) {
        await commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    },
    [SAVE_DONATION_METER]: async ({
      state,
      commit,
      dispatch,
      getters,
      rootGetters
    }, { collectionPlanUrl, secretToken, allowedOrigins, meta }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        // if secretToken is set, operate on that statsendpoint
        const currentOrganization = rootGetters['organization/currentOrganization']
        let statsendpoint = null
        if (secretToken) {
          statsendpoint = getters.statsendpointBySecretToken[secretToken]
        }

        if (!statsendpoint) {
          // Create a new one
          const response = await rootGetters.restApi.post(`${collectionPlanUrl}/stats_endpoint/`, {
            allowed_origins: allowedOrigins
          })
          if (response.status >= 200 && response.status < 300) {
            statsendpoint = response.data
          } else {
            throw response
          }
        } else {
          // Update allowedOrigins in statsendpoint
          const response = await rootGetters.restApi.patch(`${collectionPlanUrl}/stats_endpoint/`, {
            allowed_origins: allowedOrigins
          })
          if (response.status !== 200) {
            throw response
          }
          statsendpoint = response.data
        }
        // Update store
        const tasks = [
          commit(SET_COLLECTION_PLAN_STATSENDPOINTS, {
            collectionPlanUrl,
            statsendpoints: [
              ...state.rawStatsendpointsByCollectionPlan[collectionPlanUrl].filter(item => item.secret_token !== statsendpoint.secret_token),
              statsendpoint
            ],
          })
        ]

        // Update plan meta
        tasks.push(
          (async () => {
            const updatedPlan = await dispatch(PATCH_COLLECTION_PLAN, {
              url: collectionPlanUrl,
              data: {
                meta: {
                  ...meta,
                  donation_meter: {
                    ...(meta?.donation_meter || {}),
                    secret_token: statsendpoint.secret_token
                  }
                }
              }
            })
            await commit(UPDATE_COLLECTION_PLANS, { organizationUrl: currentOrganization.url, data: updatedPlan })
          })()
        )

        await Promise.allSettled(tasks)
      } catch (error) {
        if (error.response) {
          commit(SET_ERROR_MESSAGE, { message: `${i18n.t('messages.error.send')}: ${error.response.data.message || error.message}` }, { root: true })
        } else {
          commit(SET_ERROR_MESSAGE, { message: `${i18n.t('messages.error.send')}: ${error}` }, { root: true })
        }
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return null
    },
    [DELETE_DONATION_METER]: async ({
      commit,
      dispatch,
      getters,
      rootGetters
    }, { collectionPlanUrl }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const currentOrganization = rootGetters['organization/currentOrganization']
        await rootGetters.restApi.delete(collectionPlanUrl + 'stats_endpoint/')
        const response = await dispatch(PATCH_COLLECTION_PLAN, {
          url: collectionPlanUrl,
          data: {
            meta: {
              donation_meter: null,
            }
          }
        })
        commit(UPDATE_COLLECTION_PLANS, { organizationUrl: currentOrganization.url, data: response })

        return response
      } catch (error) {
        commit(SET_ERROR_MESSAGE, { message: `${i18n.t('messages.error.send')}: ${error}` }, { root: true })
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return null
    },
    [FETCH_STATSENDPOINTS_FOR_COLLECTION_PLAN]: async ({ commit, rootGetters }, url) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const response = await rootGetters.restApi.get(`${url}stats_endpoint/`)
        if (response.status >= 200 && response.status < 300) {
          await commit(SET_COLLECTION_PLAN_STATSENDPOINTS, { collectionPlanUrl: url, statsendpoints: [response.data] })
        } else if (response.status === 404) {
          await commit(SET_COLLECTION_PLAN_STATSENDPOINTS, { collectionPlanUrl: url, statsendpoints: [] })
        } else {
          throw response
        }
        return response
      } catch (error) {
        if (error.response?.status === 404) {
          // Special case for stats_endpoint singleton property
          await commit(SET_COLLECTION_PLAN_STATSENDPOINTS, { collectionPlanUrl: url, statsendpoints: [] })
        } else {
          commit(SET_ERROR_MESSAGE, { message: `${i18n.t('messages.error.send')}: ${error}` }, { root: true })
        }
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
      return null
    }
  }
}
